module.exports = __webpack_public_path__ + "dissapore.png?aa277c75dde70a3903acb45d7db99f2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/dissapore.png
// module id = 127
// module chunks = 0